import { useEffect, useState, memo } from "react";
import { formatCreateP10 } from "../helpers/formatCreateP10";
import { Chip } from "@mui/material";
import { MdWifi, MdWifiOff, MdCheckCircleOutline, MdOutlineCancel, MdHourglassEmpty } from "react-icons/md";
import { differenceInMinutes } from 'date-fns';
import SvgPanel from "./SvgPanel";

const statusConfig = {
  true: { label: "Actualizado", bg: "#fefefe", color: "#166534", icon: <MdCheckCircleOutline color="#22c55e" />, },
  false: { label: "Sin Respuesta", bg: "#fefefe", color: "#991b1b", icon: <MdOutlineCancel color="#ef4444" />, },
  pending: { label: "Pendiente", bg: "#fefefe", color: "#9a3412", icon: <MdHourglassEmpty color="#f97316" className="animate-spin" />, },
};

const StatusChip = memo(function StatusChip({ update }) {
  const [, forceRender] = useState(0);
  useEffect(() => {
    const timeout = setTimeout(() => { forceRender(v => v + 1); }, 330000);
    return () => clearTimeout(timeout);
  }, []);

  const diff = differenceInMinutes(new Date(), new Date(update.ts));

  const config = statusConfig[
    update.LastChangeMade
      ? "true"
      : diff >= process.env.REACT_APP_TIME_LIMIT
        ? "false"
        : "pending"
  ];

  return (
    <Chip
      className="w-fit !px-1 me-4"
      size="small"
      label={config.label}
      sx={{
        fontWeight: 600,
        backgroundColor: config.bg,
        color: config.color,
        fontSize: 14,
      }}
      icon={config.icon}
    />
  );
});

export default function PanelGrafico({ className, datos }) {
  const [dataArray, setDataArray] = useState(formatCreateP10());

  useEffect(() => { setDataArray(formatCreateP10(datos)) }, [datos]);
  return (
    <>
      <div className="min-[1500px]:h-full min-[1500px]:aspect-[1.2] max-[1499px]:w-full max-[1499px]:flex max-[1499px]:flex-col max-[1499px]:gap-0 ">

        <div className="flex justify-between items-center bg-gradient-to-b from-[#0A2540] to-[#0F3460] py-3 lg:py-4 rounded-t-xl lg:rounded-t-2xl">
          <div className="flex justify-between items-center">
            <h1 className="text-left font-bold text-lg lg:text-2xl antialiased text-white ps-4"> VISTA PANEL </h1>
          </div>
          <div className="flex justify-between items-center">
            <StatusChip update={datos.connection.LastChange} />
            <div className="bg-[#fefefe] p-1 me-4 rounded-full">
              {datos.connection.Online ? (<MdWifi size={20} color="#22c55e" />) : (<MdWifiOff size={20} color="#ef4444" />)}
            </div>
          </div>
        </div>
        <SvgPanel className={className} dataArray={dataArray} />
      </div>
    </>
  );
}